import { render, staticRenderFns } from "./userPage.vue?vue&type=template&id=07bcc25b"
import script from "./userPage.vue?vue&type=script&lang=js"
export * from "./userPage.vue?vue&type=script&lang=js"
import style0 from "./userPage.vue?vue&type=style&index=0&id=07bcc25b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports